import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    Data: '',
    Date: '',
    SelectedEmp: [],
    Shifts: [],
    AbsentReason: [],
    AbsentReasonAll: [],
    EmployeeToSwap: [],
}

export const dashboardReducer = createSlice({
    name: 'dashboardReducer',
    initialState,
    reducers: {
        setDashboard: (state, action) => {
            state.Data = action.payload
        },
        setDashboardDate: (state, action) => {
            state.Date = action.payload
        },
        setDashboardSelectedEmp: (state, action) => {
            state.SelectedEmp = action.payload
        },
        setDashboardShifts: (state, action) => {
            state.Shifts = action.payload
        },
        setDashboardAbsentReason: (state, action) => {
            state.AbsentReason = action.payload
        },
        setDashboardAbsentReasonAll: (state, action) => {
            state.AbsentReasonAll = action.payload
        },
        setDashboardEmployeeToSwap: (state, action) => {
            state.EmployeeToSwap = action.payload
        },

    },
})

export const { setDashboard, setDashboardDate, setDashboardSelectedEmp, setDashboardShifts, setDashboardAbsentReason, setDashboardAbsentReasonAll, setDashboardEmployeeToSwap } = dashboardReducer.actions

export default dashboardReducer.reducer
